// Küçük segment kontrol (native <select> yerine modern toggle grubu).
export function Segmented({ value, options, onChange, title }) {
  return (
    <div title={title} style={{ display: 'inline-flex', background: 'var(--input-bg)', border: '1px solid var(--border-color)', borderRadius: 10, padding: 2, gap: 2 }}>
      {options.map((o) => {
        const active = value === o.value;
        return (
          <button
            key={String(o.value)}
            type="button"
            title={o.title || o.label}
            onClick={() => onChange(o.value)}
            style={{
              border: 'none', cursor: 'pointer', borderRadius: 8, padding: '4px 10px', fontSize: 12, fontWeight: 700,
              background: active ? 'var(--accent)' : 'transparent',
              color: active ? '#fff' : 'var(--text-secondary)',
              lineHeight: 1.4,
            }}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
